import React from "react";
import {
  Grid,
  MenuItem,
  Select,
  FormControl,
  Typography,
  MenuList,
  TextField
} from "@material-ui/core";
import dayjs from "dayjs";

import DatePicker from "react-datepicker";

import WithAuth from "../containers/WithAuth";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import rem from "../utils/rem";
import CustomClipVideoEditor from "../components/CustomClipVideoEditor";

const Wrapper = styled.div`
  padding: 0 2rem;
`;

const SelectableGameMenuItem = withStyles({
  root: {
    display: "inline-block",
    textAlign: "center",
    width: "100%",
    "&:hover": {
      color: "#002D72",
      borderRight: "3px solid #002D72",
      backgroundColor: "white !important"
    }
  },
  selected: {
    color: "#002D72",
    borderRight: "3px solid #002D72",
    backgroundColor: "white !important"
  }
})(MenuItem);

const SelectableAtBatMenuItem = withStyles({
  root: {
    display: "inline-block",
    textAlign: "left",
    width: "100%",
    overflowX: "scroll",
    paddingLeft: "5px",
    "&:hover": {
      color: "#002D72",
      borderLeft: "3px solid #002D72",
      backgroundColor: "white !important"
    }
  },
  selected: {
    color: "#002D72",
    borderLeft: "3px solid #002D72",
    backgroundColor: "white !important"
  }
})(MenuItem);

const DatePickerWrapper = styled.div`
  display: inline-block;
  padding-right: ${rem(24)};
`;

const DateInput = styled.input`
  float: left;
  text-align: center;
  line-height: ${rem(16)};
  border-radius: ${rem(4)};
  border: 1px solid #aeaeae;
  font-size: ${rem(13)};
  padding: ${rem(6)} 0 ${rem(6)} 0;
  cursor: pointer;
`;

class CustomGameClipEditor extends React.Component {
  componentWillMount() {
    this.initialize().then(() => {
      /* Do nothing */
    });
  }

  componentWillUnmount() {
    const { createCustomClipStore, gameMetadataStore } = this.props;
    createCustomClipStore.reset();
    gameMetadataStore.reset();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      this.initialize().then(() => {
        /* Do nothing */
      });
    }
  }

  async initialize() {
    const { createCustomClipStore, gameMetadataStore } = this.props;
    const params = new URLSearchParams(this.props.location.search);

    let gamePk = params.get("gamePk");
    const assetName = params.get("assetName");
    const feed = params.get("feed");
    const startTime = params.get("startTime");
    const endTime = params.get("endTime");
    const atBatIndex = params.get("atBatIndex");
    const dateParam = params.get("date");

    if (gamePk) {
      gamePk = parseInt(gamePk, 10);
      await gameMetadataStore.setGamePk(gamePk);
    } else {
      gameMetadataStore.reset();
    }

    if (dateParam) {
      gameMetadataStore.setDate(dayjs(dateParam).toDate());
    }

    const date = dayjs(gameMetadataStore.date).format("YYYY-MM-DD");

    if (gamePk && atBatIndex !== null && atBatIndex !== undefined) {
      await createCustomClipStore.initializeAtBat(
        gamePk,
        date,
        startTime,
        endTime,
        assetName,
        parseInt(atBatIndex, 10)
      );
    } else if (gamePk) {
      await createCustomClipStore.initialize(
        gamePk,
        date,
        startTime,
        endTime,
        feed,
        assetName
      );
    } else {
      createCustomClipStore.reset();
      gameMetadataStore.reset();
    }
  }

  render() {
    const {
      routerStore,
      createCustomClipStore,
      gameMetadataStore,
      sportsReferenceStore
    } = this.props;

    let editorElement = (
      <Typography style={{ padding: "1rem" }}>
        Select a game to custom clip
      </Typography>
    );

    if (
      gameMetadataStore.selectedGame &&
      (createCustomClipStore.fetching || createCustomClipStore.selectedAsset)
    ) {
      editorElement = <CustomClipVideoEditor />;
    }

    return (
      <Wrapper>
        <Grid container style={{ marginTop: 20 }} spacing={4}>
          <Grid
            item
            xs={2}
            style={{
              textAlign: "center",
              borderRight: "1px solid rgba(0, 0, 0, 0.12)",
              paddingRight: 0,
              paddingLeft: 0,
              height: "90vh",
              overflowY: "scroll"
            }}
          >
            <DatePickerWrapper>
              <DatePicker
                selected={gameMetadataStore.date}
                onChange={date => gameMetadataStore.setDate(date)}
                customInput={<DateInput />}
              />
            </DatePickerWrapper>
            <FormControl>
              <Select
                id="sport-selector-select"
                label="Sport"
                value={gameMetadataStore.sportId}
                onChange={e => gameMetadataStore.setSportId(e.target.value)}
                style={{ padding: "0 1rem" }}
              >
                {sportsReferenceStore.sports.map(s => (
                  <MenuItem key={s.code} value={s.id}>
                    {s.abbreviation}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <MenuList
              style={{
                marginTop: "0.5rem",
                textAlign: "center"
              }}
            >
              {gameMetadataStore.games.map(g => {
                return (
                  <SelectableGameMenuItem
                    selected={
                      gameMetadataStore.selectedGame &&
                      g.gamePk === gameMetadataStore.selectedGame.gamePk
                    }
                    key={g.gamePk}
                    onClick={() => {
                      // Changing a game we want to reset everything
                      if (
                        !gameMetadataStore.selectedGame ||
                        g.gamePk !== gameMetadataStore.selectedGame.gamePk
                      ) {
                        routerStore.history.push(
                          `/custom-clips?gamePk=${g.gamePk}&date=${dayjs(
                            gameMetadataStore.date
                          ).format("YYYY-MM-DD")}`
                        );
                      }
                    }}
                  >
                    {g.description}
                  </SelectableGameMenuItem>
                );
              })}
            </MenuList>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 0 }}>
            {editorElement}
          </Grid>
          {gameMetadataStore.selectedGame &&
            gameMetadataStore.selectedGame["atBats"] && (
              <Grid
                item
                xs={2}
                style={{
                  borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
                  padding: 0,
                  height: "90vh",
                  overflowY: "scroll"
                }}
              >
                <TextField
                  id="standard-basic"
                  label="Description"
                  variant="standard"
                  placeholder="Description"
                  fullWidth
                  style={{ marginLeft: "5px" }}
                  value={gameMetadataStore.descriptionFilter}
                  onChange={e =>
                    (gameMetadataStore.descriptionFilter = e.target.value)
                  }
                />
                <MenuList>
                  {gameMetadataStore.filteredAtBats.map(atBat => {
                    return (
                      <SelectableAtBatMenuItem
                        selected={
                          atBat["atBatIndex"] ===
                          createCustomClipStore.atBatIndex
                        }
                        key={atBat.startTime}
                        onClick={() => {
                          // Editing an at bat we want to set the timings in whatever asset is selected
                          const clipUrl = `/custom-clips?gamePk=${
                            createCustomClipStore.gamePk
                          }&startTime=${atBat["startTime"]}&endTime=${
                            atBat["endTime"]
                          }&atBatIndex=${atBat["atBatIndex"]}&assetName=${
                            createCustomClipStore.selectedAsset.name
                          }&date=${dayjs(gameMetadataStore.date).format(
                            "YYYY-MM-DD"
                          )}`;
                          routerStore.history.push(clipUrl);
                        }}
                        style={{
                          color: atBat.isScoringPlay
                            ? "darkgoldenrod"
                            : "inherit"
                        }}
                      >
                        {atBat.isTopInning ? (
                          <KeyboardArrowUp
                            style={{ verticalAlign: "bottom" }}
                          />
                        ) : (
                          <KeyboardArrowDown
                            style={{ verticalAlign: "bottom" }}
                          />
                        )}{" "}
                        {atBat.inning} - {atBat.description}
                      </SelectableAtBatMenuItem>
                    );
                  })}
                </MenuList>
              </Grid>
            )}
        </Grid>
      </Wrapper>
    );
  }
}

export default WithAuth(
  inject(
    "routerStore",
    "gameMetadataStore",
    "sportsReferenceStore",
    "createCustomClipStore"
  )(observer(CustomGameClipEditor))
);



// WEBPACK FOOTER //
// ./src/pages/CustomGameClipEditor.js